import { House, LandPlot, Key, Cog } from 'lucide-react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export const Sidebar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  
  const menuItems = [
    { path: "/products", label: t('sidebar.products'), icon: House },
    { path: "/areas", label: t('sidebar.areas'), icon: LandPlot },
    { path: "/api-keys", label: t('sidebar.apiKeys'), icon: Key },
    { path: "/configs", label: t('sidebar.configs'), icon: Cog },
  ];

  return (
    <div className="drawer-side z-30">
      <label htmlFor="my-drawer" className="drawer-overlay"></label>
      <aside className="bg-[#F9FAFB] w-80 min-h-screen">
        <div className="sticky top-0 z-20 bg-[#F9FAFB]">
          <div className="p-4 pb-5 font-semibold text-xl border-b">
            {t('sidebar.adminPanel')}
          </div>
        </div>
        <ul className="menu p-4 gap-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
              (item.path === "/products" && location.pathname === "/");
            
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`rounded-lg text-[#373F6B] ${
                    isActive 
                      ? 'bg-[#E9ECEF] shadow-[0_2px_4px_0_rgba(0,0,0,0.10)]' 
                      : 'hover:bg-[#E9ECEF]'
                  }`}
                >
                  <Icon size={12} />
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </aside>
    </div>
  );
}; 